(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    class CollectionBreadcrumb extends HTMLElement {
    constructor() {
      super();
      this.updateBreadcrumbs();
    }

    updateBreadcrumbs() {
      const prevUrl = this.getPrevUrl();
      const isCollection = this.checkUrl(prevUrl);

      if(prevUrl && isCollection ) {
        this.addLink(prevUrl);
        this.closest('.breadcrumbs__item').classList.remove('hidden');
      } else {
        this.closest('.breadcrumbs__item').classList.add('hidden');
      }
    }

    getPrevUrl() {
      return document.referrer;
    }

    checkUrl(url) {
      return url.includes('/collections/');
    }

    formatUrl(url) {
      const splitUrl = url.split('/');
      const formatUrlString = splitUrl.pop();
      return formatUrlString.replaceAll('-', ' ');
    }

    addLink(url) {
      const breadcrumb = this.querySelector('a');
      breadcrumb.href = url;
      breadcrumb.innerHTML = this.formatUrl(url).split('?')[0];
    }
}

customElements.define('collection-breadcrumb', CollectionBreadcrumb);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["country-localization"] && !Shopify.designMode) return;
  try {
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      if (event.currentTarget.dataset.value) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      } else {
        return;
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const isChild =
        this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
    
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  }

  customElements.define('localization-form', LocalizationForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-with-purchase"] && !Shopify.designMode) return;
  try {
    class GWP extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.giftToAdd = this.getAttribute('data-add-gift');
      if (this.giftToAdd) {
        const formData = {
          items: [
            {
              id: this.giftToAdd,
              quantity: 1,
              properties: {
                _gwp: true,
              },
            },
          ],
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            document.dispatchEvent(new CustomEvent('refresh-cart', {
              detail: {
                source: 'gift-with-purchase',
                sourceId: this.giftToAdd,
                component: this
              }
            }));
          })
          .catch((error) => console.error('Error adding gift:', error));
      }
    }
  }

  customElements.define('gift-with-purchase', GWP);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    class Megamenu extends HTMLElement {
    constructor() {
      super();
      this.allItems = document.querySelectorAll('.mega-menu__item');
      this.allTriggers = document.querySelectorAll('.js-mega-hover');
      this.curEl;
      let lastScrollY = 0;
    }

    connectedCallback() {
      this.allTriggers.forEach((menuItemEl) => {
        menuItemEl.addEventListener('mouseover', () => {
          this.menuItem = menuItemEl;
          this.menuIndex = menuItemEl.getAttribute('data-menu-index');
          this.showMegaMenu();
          this.showMegamenuItem();
        });
      });

      document.querySelector('.header-wrapper').addEventListener('mouseout', () => {
        this.hideMegaMenu();
      });

      document.onmousemove = (e) => {
        e = e || window.event;
        this.curEl = e.target || e.srcElement;
      };

      window.addEventListener("scroll", () => {
        const currentScrollY = window.scrollY;
         if (currentScrollY > this.lastScrollY && currentScrollY > 100) {
          this.forceHideMegaMenu();
        }
        this.lastScrollY = currentScrollY;
      })
    }

    showMegaMenu() {
      setTimeout(() => {
        if (this.curEl === this || this.curEl === this.menuItem) {
          this.classList.add('active');
          document.body.classList.add('blur');
          document.body.classList.add('megamenu--active');
        } else {
          if (document.body.classList.contains('megamenu--active')) {
            this.classList.remove('active');
            document.body.classList.remove('blur');
            document.body.classList.remove('megamenu--active');
          }
        }
      }, 50);
    }

    showMegamenuItem() {
      this.allItems.forEach((item) => {
        item.classList.remove('active');
      });
      this.allTriggers.forEach((trigger) => {
        trigger.classList.remove('active');
      });
      this.menuItem.classList.add('active');

      const currentItem = document.querySelector(`.mega-menu__item[data-menu-index="${this.menuIndex}"]`);
      if (currentItem) {
        currentItem.classList.add('active');
      }
    }

    forceHideMegaMenu() {
      this.classList.remove('active');
      document.body.classList.remove('blur', 'megamenu--active');
      this.menuItem?.classList.remove('active');
    }

    hideMegaMenu() {
      setTimeout(() => {
        if (this.curEl !== this && this.curEl !== this.menuItem && !this.curEl.closest('.header-wrapper')) {
          if (document.body.classList.contains('megamenu--active')) {
            this.classList.remove('active');
            document.body.classList.remove('blur');
            document.body.classList.remove('megamenu--active');
            this.menuItem.classList.remove('active');
          }
        }
      }, 50);
    }
  }

  customElements.define('mega-menu', Megamenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ometria-form"] && !Shopify.designMode) return;
  try {
    (function () {
  const form = document.querySelector('#ometria_form_01');
  if (!form) return;

  let submitted = false;
  const startTime = Date.now();

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (submitted) return;

    // Honeypot check
    const trap = form.querySelector('input[name="__email"]');
    if (trap && trap.value.trim() !== '') {
      return;
    }

    // Bot timing check (basic human signal)
    if (Date.now() - startTime < 1200) {
      return;
    }

    const emailInput = form.querySelector('input[name="ue"]');
    if (!emailInput || emailInput.value.trim().length < 3) {
      alert('Please enter your email');
      return;
    }

    submitted = true;

    const submitButton = form.querySelector('input[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    const formData = new FormData(form);

    // Allow‑list fields only    
    const allowed = new Set([
      '__form_id',
      'email',
      '__email',
      '@account',
      '@return_url',
      '@subscription_status',
      '@add_to_lists',
      'ue',
      'submit',
      'properties.product_name',
      'properties.product_id',
      'properties.signup_source'
    ]);

    for (const key of formData.keys()) {
      if (!allowed.has(key)) {
        formData.delete(key);
      }
    }

    const body = new URLSearchParams(formData).toString();

    try {
      const res = await fetch(
        'https://api.ometria.com/forms/signup/ajax',
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body
        }
      );

      if (!res.ok) throw new Error('Request failed');

      const container = document.querySelector(
        '#email-notification__form'
      );
      if (container) {
        const thankYouMessage =
          container.dataset.thankYouMessage || 'Thank you for signing up.';

        container.textContent = thankYouMessage;
      }
    } catch (e) {
      submitted = false;
      if (submitButton) submitButton.disabled = false;
      alert('Something went wrong — please try again.');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-sidebar"] && !Shopify.designMode) return;
  try {
    class SidebarMenu extends HTMLElement {
    constructor() {
      super();
      this.toggleBtn = this.querySelector(".sidebar-toggle");
      this.list = this.querySelector(".main-page__sidebar");
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener("click", this.handleClick);
      }
    }

    disconnectedCallback() {
      if (this.toggleBtn) {
        this.toggleBtn.removeEventListener("click", this.handleClick);
      }
    }

    handleClick() {
      if (this.classList.contains('is-open')) { 
        this.list.style.maxHeight = 0;
        this.classList.remove('is-open'); } 
      else { 
        const fullHeight = this.list.scrollHeight; 
        this.list.style.maxHeight = fullHeight + 'px';
        this.classList.add('is-open'); 
      }
    }
  }

customElements.define("sidebar-menu", SidebarMenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('.product-card__video');
      this.container = this.querySelector('.media-model-first');

      if (!this.video) return;

      if (this.container) {
        this.startVideo();
      }

      this.addEventListener('mouseenter', this.onHoverStart.bind(this));
      this.addEventListener('mouseleave', this.onHoverEnd.bind(this));
    }

    startVideo() {
      this.video.play().catch(() => {});
    }

    stopVideo() {
      this.video.pause();
      this.video.currentTime = 0;
    }

    onHoverStart() {
      if (this.container) {
        this.stopVideo();
      } else {
        this.startVideo();
      }
    }

    onHoverEnd() {
      if (this.container) {
        this.startVideo();
      } else {
        this.stopVideo();
      }
    }

    initImagesGallery() {}
  }

  customElements.define('product-card', ProductCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    class StickyATC extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
  }

  connectedCallback() {
    this.productSection = document.querySelector('.product-section');

    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);

    this._onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
  }

  _onScroll() {
    if (!this.productSection) return;

    const bottom = this.productSection.getBoundingClientRect().bottom;

    if (bottom <= window.innerHeight) {
      this.classList.add('is-sticky');
    } else {
      this.classList.remove('is-sticky');
    }
  }
}

customElements.define('sticky-atc', StickyATC);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    class VideoBlock extends HTMLElement {
  constructor() {
    super();
    this.videoWrapper = this;
    this.video = this.querySelector('video');
    this.videoSrc = this.video.querySelector('source').getAttribute('src')
    this.playButton = this.querySelector('.video-play-button');
    this.muteButton = this.querySelector('.video-mute-button');
  }

  connectedCallback() {
    if (!this.video) return;

    this.syncPlayIcon();
    this.syncMuteIcon();
    this.setupEvents();
    this.pauseVideoOnLeaveViewport();
    this.playVideoOnEnterViewport();
    this.unloadDesktopOnlyVideoOnMobile();

    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        //this.video.pause();
      }
    } catch (e) {}
  }

  setupEvents() {
    if (this.playButton) {
      this.playButton.addEventListener('click', () => {
        if (this.video.paused || this.video.ended) {
          this.video.play();
        } else {
          this.video.pause();
        }
        this.syncPlayIcon();
      });
    }

    if (this.muteButton) {
      this.muteButton.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        this.syncMuteIcon();
      });
    }

    ['play', 'playing', 'pause', 'ended'].forEach(evt => {
      this.video.addEventListener(evt, () => this.syncPlayIcon());
    });
  }

  syncPlayIcon() {
    const playing = !this.video.paused && !this.video.ended;
    this.playButton?.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');

    this.playButton?.querySelector('.video-play')?.classList.toggle('hidden', playing);
    this.playButton?.querySelector('.video-pause')?.classList.toggle('hidden', !playing);
  }

  syncMuteIcon() {
    const muted = !!this.video.muted;
    this.muteButton?.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');

    this.muteButton?.querySelector('.video-volume-on')?.classList.toggle('hidden', muted);
    this.muteButton?.querySelector('.video-volume-off')?.classList.toggle('hidden', !muted);
  }


  pauseVideoOnLeaveViewport() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.video.pause();
          this.syncPlayIcon();
        }
      });
    }, { threshold: 0.25 });

    observer.observe(this);
  }

  playVideoOnEnterViewport() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.video.play();
          this.syncPlayIcon();
        }
      });
    }, { threshold: 0.25 });

    observer.observe(this);
  }

  
 // time to say goodbye to mobile data usage
  unloadDesktopOnlyVideoOnMobile() {
    let isMobile = navigator.appVersion.indexOf("Mobile") !== -1;
    let viewPortWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    
    if (isMobile && viewPortWidth < 768 && this.classList.contains('desktop-only')) {

      let videoSrc = this.video.querySelector('source').getAttribute('src');
      
      this.video.setAttribute('data-src', videoSrc);
      this.video.querySelector('source').setAttribute('src' , '');  
      this.video.load();

      window.addEventListener('resize', () => {
        let viewPortWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (viewPortWidth >= 768) {
          this.video.querySelector('source').setAttribute('src' , this.video.getAttribute('data-src')); 
          this.video.load();
          this.syncPlayIcon();
        } else {
          this.video.querySelector('source').setAttribute('src' , ''); 
          this.video.load();
        }
      });

    }
  }

}

customElements.define('video-block', VideoBlock);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (evt) {
    const wishlistButton = evt.target.closest('a.js-open-wishlist-drawer');
    if (!wishlistButton) return;
    evt.preventDefault();

    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;

    const toggleEvent = new CustomEvent('drawer-toggle', {
      detail: { trigger: wishlistButton }
    });
    drawer.dispatchEvent(toggleEvent);
  });
  } catch(e) { console.error(e); }
})();

})();
